import { render } from "./RiDragDropLine.vue?vue&type=template&id=d80ea678"
import script from "./RiDragDropLine.vue?vue&type=script&lang=js"
export * from "./RiDragDropLine.vue?vue&type=script&lang=js"
script.render = render

export default script